import { FilePlus02, X } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { Input } from "@/components/base/input/input";

type CreateListFormProps = {
  listName: string;
  onListNameChange: (name: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isDisabled?: boolean;
  autoFocus?: boolean;
};

export const CreateListForm = ({
  listName,
  onListNameChange,
  onSubmit,
  onCancel,
  isDisabled = false,
  autoFocus = true,
}: CreateListFormProps) => {
  return (
    <div className="px-6 pb-4">
      <div className="p-4 border-2 border-brand rounded-lg bg-gray-50">
        <div className="flex items-start justify-between gap-2 mb-3">
          <span className="text-sm font-medium text-gray-700">
            List name <span className="text-brand-primary">*</span>
          </span>
          <button type="button" onClick={onCancel} className="text-gray-400 hover:text-gray-600">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <Input
            placeholder="New List name"
            value={listName}
            onChange={onListNameChange}
            className="flex-1"
            autoFocus={autoFocus}
            onKeyDown={(e) => {
              if (e.key === "Enter" && listName.trim()) {
                e.preventDefault();
                onSubmit();
              } else if (e.key === "Escape") {
                onCancel();
              }
            }}
          />
          <Button
            type="button"
            color="primary"
            size="md"
            onClick={onSubmit}
            isDisabled={isDisabled || !listName.trim()}
            iconLeading={<FilePlus02 className="w-4 h-4" />}
          >
            Create new List
          </Button>
        </div>
      </div>
    </div>
  );
};
